import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormElement } from '@rx-applications/shared/utils-forms';
import { ReactiveFormsModule } from '@angular/forms';
import { AsPipeModule } from '@rx-applications/shared/utils';
import { RoomsFormTemplates } from '../../enums/rooms-form-templates.enum';
import { Room } from '@rx-applications/clientsite/shared/utils';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { ClientsiteCheckoutRoomHeaderComponent } from '../clientsite-checkout-room-header/clientsite-checkout-room-header.component';
import { ClientsiteCheckoutGuestsComponent } from '../clientsite-checkout-guests/clientsite-checkout-guests.component';

@Component({
  selector: 'rx-applications-clientsite-checkout-room',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AsPipeModule,
    TranslocoDirective,
    ClientsiteCheckoutRoomHeaderComponent,
    ClientsiteCheckoutGuestsComponent,
  ],
  templateUrl: './clientsite-checkout-room.component.html',
  styleUrls: ['./clientsite-checkout-room.component.scss'],
  providers: [translationProvider],
})
export class ClientsiteCheckoutRoomComponent extends FormElement implements OnInit {
  protected readonly RoomsFormTemplates = RoomsFormTemplates;

  TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  Room: Room;

  constructor() {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.push(RoomsFormTemplates.ROOM);
  }
}
